import { render, staticRenderFns } from "./parentList.vue?vue&type=template&id=11dd9afd&"
import script from "./parentList.vue?vue&type=script&lang=js&"
export * from "./parentList.vue?vue&type=script&lang=js&"
import style0 from "./parentList.vue?vue&type=style&index=0&id=11dd9afd&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports